import {Component, Input} from "@angular/core";

/**
 * A component that renders an SVG icon for "Camera Off"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-camera-off',
    templateUrl: './icon-camera-off.component.html',
    styleUrls: ['./icon-camera-off.component.scss'],
    standalone: false
})
export class IconCameraOffComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
